export enum EAdOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}
